
export const CIS_LEVELS = [
  {
    key: 'bronze',
    label: 'Bronze',
    min: 0,
    max: 39_999,
    multiplier: 1.0,
    color: 'text-amber-700',
    bg: 'bg-surface-container-high',
    border: 'border-on-background/10',
    icon: '/icons/bronze.png',
  },
  {
    key: 'silver',
    label: 'Silver',
    min: 40_000,
    max: 399_999,
    multiplier: 1.1,
    color: 'text-on-surface-variant',
    bg: 'bg-secondary-container/20',
    border: 'border-secondary-container',
    icon: '/icons/silver.png',
  },
  {
    key: 'gold',
    label: 'Gold',
    min: 400_000,
    max: 3_999_999,
    multiplier: 1.25,
    color: 'text-primary-container',
    bg: 'bg-primary-container/20',
    border: 'border-primary-container/40',
    icon: '/icons/gold.png',
  },
  {
    key: 'diamond',
    label: 'Diamond',
    min: 4_000_000,
    max: null,
    multiplier: 1.5,
    color: 'text-blue-400',
    bg: 'bg-blue-50/30',
    border: 'border-blue-200',
    icon: '/icons/diamond.png',
  },
]

export const CIS_MAX = 10_000_000

// Returns the level object for a given CIS balance.
export function getLevelForCis(cis) {
  const score = Number(cis) || 0
  return [...CIS_LEVELS].reverse().find((l) => score >= l.min) ?? CIS_LEVELS[0]
}
export function getNextLevel(cis) {
  const current = getLevelForCis(cis)
  const idx = CIS_LEVELS.findIndex((l) => l.key === current.key)
  return CIS_LEVELS[idx + 1] ?? null
}

export function formatMultiplier(m) {
  return `${m}x`
}

// Applies a level's multiplier to a base reward amount (e.g. base CPX/task
// reward × the user's current level multiplier).
export function applyMultiplier(baseAmount, cis) {
  const level = getLevelForCis(cis)
  return Math.round(Number(baseAmount) * level.multiplier * 100) / 100
}
